export default __webpack_public_path__ + "media/images/icons/sad-tear-regular-1ba7873b006deed55be16a3cd6891770.svg";